<template>
    <div style="height: 100%; width: 100%;position: relative;" ref="chatScrollView">
        <!-- 开场白 -->
        <div class="egclass" v-if="(prologue && agentVar && agentVar.length > 0) || diaArr.length > 0">
            <!-- 变量参数 -->
            <div style="width: 100%;margin: 10px auto;" v-if="agentVar && agentVar.length > 0">
                <agent-key :user_input_form="agentVar" :inputsInfo="inputsInfo" :agentVarObj="agentVarObj"
                    @inputsInfoChange="handleInputsInfoChange" />

            </div>
            <div style="width: 100%;" class="textWrapClass">{{ prologue.textValue }}</div>
            <div style="width: 100%;margin: 20px 0 0;" v-if="prologue && prologue.eg && prologue.eg.length > 0">
                <div v-for="(itemName, id) in prologue.eg" :key="id"
                    style="max-width: 100%; margin: 0 0 10px 10px;color: #356CFD;" @click="gotoEg(itemName)">
                    <span style="border-bottom: 1px solid #356CFD;padding-bottom: 5px;">{{ itemName }}</span>
                </div>
            </div>
        </div>
        <div v-else style="position: absolute;top: 30%;left: 0%;width: 100%;min-height:600px;">
            <div style="width: 100%;text-align: center;font-size: 30px;font-weight: 800;letter-spacing: 0.2em;"
                class="textWrapClass">有什么我能帮你的吗?
            </div>
            <div style="width: 100%;margin: 20px 0 0;display: flex;align-items: center;flex-wrap: wrap;">
                <div v-for="(itemName, id) in prologue.eg" :key="id"
                    style="margin: 10px;color:black;padding: 10px 15px;border-radius: 10px;background-color:#f6f6f6;"
                    @click="gotoEg(itemName)">
                    {{ itemName }}
                </div>
            </div>
        </div>
        <!-- 聊天内容 -->
        <template v-for="(item, index) in diaArr">
            <div v-if="item.type == 1 || item.type == 3 || item.type == 4">
                <div :class="[item.type == 4 ? 'egclass' : 'message']">

                    <div v-if="item.type == 3">
                        {{ item.conter }}
                        <span>{{ loadingText }}</span>
                    </div>



                    <div v-if="item.type == 1 && item.think">
                        <div style="color: #356CFD;height: 40px;line-height: 40px;width: 100%;background-color:#EBEEF5;
                                    border-radius: 10px;padding-left: 20px;" @click="collapseTap(index)">{{ item.conter
                                        ? '已结束深度思考:' : '思考中......' }}
                            <i class="el-icon-arrow-down" style="size: 18px;margin-left: 10px;"
                                v-if="item.IsCollapse"></i>
                            <i class="el-icon-arrow-up" style="size: 18px;margin-left: 10px;" v-else></i>
                        </div>
                        <div v-if="item.IsCollapse"
                            style="width:98%;border-left: 3px solid #817e7e;padding: 10px 0 10px 10px; margin-left:15px;margin-top: 15px;
                                        margin-bottom: 15px; color:#817e7e ;line-height: 30px;word-wrap: break-word;white-space: pre-wrap;">
                            {{ item.think }}
                        </div>
                    </div>
                    <div v-if="item.type == 1 || item.type == 4" @click="handleLlmAnchorClick">
                        <div v-html="item.conter" style="width: 100%;line-height: 30px;">
                        </div>
                    </div>


                    <div style="color: #356CFD;height: 40px;line-height: 40px;width: 100%;background-color:#EBEEF5;
                                    border-radius: 10px;padding-left: 20px;margin: 10px auto;"
                        v-if="item.fileList && item.fileList.length > 0" @click="collapseFileTap(index)">
                        引用{{ item.fileList.length }}个文件作为参考
                        <i class="el-icon-arrow-down" style="size: 18px;margin-left: 10px;" v-if="item.IsFlieShow"></i>
                        <i class="el-icon-arrow-up" style="size: 18px;margin-left: 10px;" v-else></i>
                    </div>

                    <div v-if="item.IsFlieShow"
                        style="width:96%;margin: 10px auto;border-left: 3px solid #817e7e;padding-left:20px">
                        <el-collapse v-model="activeNames">
                            <template v-for="(fileListItem, fileListIndex) in item.fileList">
                                <el-collapse-item
                                    :title="'[' + fileListItem.position + ']' + ':' + fileListItem.document_name"
                                    :name="fileListItem.position">
                                    <div style="max-height: 200px;padding: 10px;overflow: auto;">
                                        {{ fileListItem.content }}
                                    </div>
                                    <div style="height: 45px;line-height: 45px;font-size: 15px;display: flex;align-items: center;
                                                flex-direction: row-reverse;border-top:1px solid #DCDFE6 ;">
                                        <div style="margin-right: 20px;color:#909399;font-size:14px"> 来自:{{
                                            fileListItem.dataset_name }}</div>
                                        <!-- <div style="margin-right: 20px;color:red;font-size:14px"
                                            @click="DownFile(fileListItem)"> 下载原文件</div> -->
                                    </div>
                                </el-collapse-item>
                            </template>
                        </el-collapse>
                    </div>

                    <div v-if="item.type == 1 && item.stop"
                        style="width: 100%;margin: 20px 0 0;display: flex;align-items: center;">
                        <div @click="conterCopy(index)">
                            <!-- 复制文本 -->
                            <i class="el-icon-copy-document" style="font-size: 24px;color: #909399;margin: 0 15px;"></i>
                        </div>
                        <div @click="restConter(index)">
                            <!-- 刷新文本 -->
                            <i class="el-icon-refresh" style="font-size: 24px;color: #909399;margin: 0 15px;"></i>
                        </div>
                        <div @click="collectClick(index)">
                            <!-- 收藏 -->
                            <i v-if="item.isCollect" class="el-icon-star-on"
                                style="font-size: 24px;color: #E6A23C;margin: 0 15px;"></i>
                            <i v-else class="el-icon-star-off"
                                style="font-size: 24px;color: #909399;margin: 0 15px;"></i>
                        </div>
                        <div @click="zanClick(index)" style="margin: 0 15px;" v-if="!item.isUnZanAcitve">
                            <!-- 点赞 -->
                            <el-image v-if="item.isZanAcitve" style="width: 25px; height: 25px;" :src="zan_active"
                                fit="fill"></el-image>
                            <el-image v-else style="width: 25px; height: 25px;" :src="zan" fit="fill"></el-image>
                        </div>
                        <div @click="unZanClick(index)" style="margin: 0 15px;" v-if="!item.isZanAcitve">
                            <!-- 踩一踩 -->
                            <el-image v-if="item.isUnZanAcitve" style="width: 25px; height: 25px;" :src="un_zan_active"
                                fit="fill"></el-image>
                            <el-image v-else style="width: 25px; height: 25px;" :src="un_zan" fit="fill"></el-image>
                        </div>
                        <div @click="outWord(item)" v-if="agrentData.aaWord == 2" style="margin: 0 15px;">
                            <!-- 导出word -->
                            <el-image style="width: 25px; height: 25px;" :src="down_icon" fit="fill"></el-image>
                        </div>
                    </div>

                    <div style="width: 100%;margin: 10px 0 0;display: flex;" v-if="item.type == 4">
                        <div>
                            <template v-for="(egText, egIndex) in item.eg">
                                <div style="margin: 0 0 10px 10px;color: #356CFD;border-bottom: 1px solid #356CFD;"
                                    @click="queryClick(egText.text)">
                                    {{ egText.text }}
                                </div>
                            </template>
                        </div>
                    </div>

                </div>

                <div style="display: flex;flex-direction: column;"
                    v-if="item.type == 1 && item.FollowUpQuery && item.FollowUpQuery.length > 1 && index == diaArr.length - 1">
                    <template v-for="(FollowUpQueryItem, FollowUpQueryIndex) in item.FollowUpQuery">
                        <div v-if="FollowUpQueryItem.text" @click="queryClick(FollowUpQueryItem.text)">
                            <span style="padding: 15px 20px;margin-left: 10px;line-height: 50px;background-color: #EBEEF5;
                                    border-radius: 5px;height: 35px;font-size: 18px;margin-top: 15px;max-width: 80%;">
                                {{ FollowUpQueryItem.text }}
                            </span>
                        </div>
                    </template>
                </div>

            </div>

            <div class="flex-right"
                style="display: flex;align-items: flex-end;flex-direction: column;margin-right: 10px;"
                v-if="item.type == 2">
                <div v-if="item.difyFiles && item.difyFiles.length > 0" class="scroll-style-light">
                    <div class="file-list">
                        <!-- 遍历上传成功的文件数组 -->
                        <div class="file-item" v-for="(file, index) in item.difyFiles" :key="index">
                            <!-- 文件图标：根据文件类型显示对应图标 -->
                            <div class="file-icon">
                                <i class="el-icon-picture"></i>
                            </div>
                            <!-- 文件信息 -->
                            <div class="file-info">
                                <!-- 文件名 -->
                                <div class="file-name">{{ file.name }}</div>
                                <!-- 文件类型 + 大小 + 字数（可选） -->
                                <div class="file-meta">
                                    {{ file.type === 'image' ? '图片' : '' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="message2">
                    {{ item.conter }}
                </div>
            </div>

        </template>
        <div style="width: 100%;" :style="{ 'height': isOver ? '300px' : '0' }">
            <div ref="eCharts1" style="width: 100%;height: 100%; margin: 20px auto;"></div>
        </div>
        <div style="height: 300px;"></div>
    </div>
</template>
<script>
import { addAiUserChatCollection, deleteAiUserChatCollection, getAiAppDetails, addAiUserChatOneDify, addAiUserChatMsg, deleteAiUserChat, getAiUserChatDetails, exportAiUserChatMsgWord } from "../../api/api";
import agentKey from "../agentKey/agentKey.vue";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import MarkdownIt from 'markdown-it';
const md = new MarkdownIt({
    html: true,
    breaks: true,
    linkify: true
});
md.renderer.rules.text = function (tokens, idx, options, env, self) {
    let text = tokens[idx].content;
    // 替换所有 \n 为 <br>，包括连续换行
    text = text.replace(/\n/g, '<br>');
    // 替换多个空格为 &nbsp;（可选，解决空格不显示问题）
    text = text.replace(/\s{2,}/g, (match) => {
        return '&nbsp;'.repeat(match.length);
    });
    const urlReg = /(https?:\/\/[^\s]+)/g;
    text = text.replace(urlReg, (url) => {
        return `<a href="${url}" target="_blank">${url}</a>`;
    });
    return text;
};
var FileSaver = require('file-saver');

export default {
    name: 'agentChat',
    components: {
        agentKey,
    },
    props: {
        agentMsg: {
            default: ""
        },
        query: {
            default: ""
        },
        uploadFiles: {
            type: Array,
            default: []
        }
    },

    data() {
        return {
            color: [
                " #4992ff",
                " #dd79ff",
                " #fddd60",
                "  #ff6e76",
                " #58d9f9",
                " #05c091",
                "  #ff8a45",
                " #8d48e3"
            ],
            echartsStr: "",
            echartsStrValue: [],
            firstArray: [],
            secondArray: [],
            isOver: false,
            isStartBtn: false,
            zan: 'https://txcloud.aojuai.com/icon/ajtools/agent/zan.png',
            zan_active: 'https://txcloud.aojuai.com/icon/ajtools/agent/zan_active.png',
            un_zan_active: 'https://txcloud.aojuai.com/icon/ajtools/agent/un_zan-active.png',
            un_zan: 'https://txcloud.aojuai.com/icon/ajtools/agent/un_zan.png',
            activeNames: [],
            typingTimer: null, // 打字机定时器
            typingSpeed: 25, // 打字速度（ms/字，可调整）
            totalAnswerText: '', // 已接收的完整文本（字符池）
            displayAnswerText: '', // 正在展示的文本（打字机实时更新）
            isTyping: false, // 是否正在执行打字机动画
            isStreamEnd: false,
            loadingNums: 0,
            loadingText: '.',
            AnswerIndex: 0,
            answerIndex: 0,
            copyImg: 'https://txcloud.aojuai.com/icon/ajtools/agent/copy.png',
            down_icon: 'https://txcloud.aojuai.com/icon/ajtools/agent/down_word.png',
            jianpan: 'https://txcloud.aojuai.com/icon/aojv/aiwx_icon/jianpan.png',
            shuaxin: 'https://txcloud.aojuai.com/icon/aojv/aiwx_icon/shuaxin.png',
            answer_arrCopy: [],
            isPopup: false,
            isOpen: false,
            yuyin2: 'https://txcloud.aojuai.com/icon/aojv/aiwx_icon/yuyin2.png',
            cjdh: 'https://txcloud.aojuai.com/icon/aojv/aiwx_icon/cjdh.png',
            isStop: false,
            think_arr: [], //思考的数组
            answer_arr: [], //答案
            stopArr: [],
            ydyKey: '',
            chatData: '', //
            conversationId: '', //大模型对话id
            isMkfShow: false,
            isFilePop: false,
            fileList: [],
            mergeArr: [],
            isMerge: false,
            AnswerMsg: '',
            ThinkIndex: 0,
            ThinkMsg: '',
            DmxIndex: 0,
            ArgChat: '', //
            agrentData: null, //当前智能体的信息
            WxAiChatSession: null, //当前会话信息
            diaArr: [], //对话聊天信息
            prologue: '', //开场白
            agentVar: [], //智能体变量参数
            agentVarObj: {},
            isAfterAnswer: null, //当前智能体是否允许开启下一步建议
            inputsInfo: {}, //当前智能体变量参数值
        };
    },
    computed: {

    },
    watch: {
        agentMsg: {
            handler(newVal, oldVal) {
                if (newVal && newVal.aaId) {
                    this.inputsInfo = {};
                    console.log(newVal);
                    if (newVal.aucId) {
                        getAiUserChatDetails({
                            aucId: newVal.aucId
                        }).then(ress => {
                            if (ress.data.aiUserChatMsgList && ress.data.aiUserChatMsgList.length > 0) {
                                const dataval = JSON.parse(JSON.stringify(ress.data));
                                console.log(dataval)
                                if (ress.data.aucAnswerEvaluate && ress.data.aucAnswerEvaluate != '{}') {
                                    var aucAnswerEvaluate = JSON.parse(ress.data.aucAnswerEvaluate);
                                    this.firstArray = aucAnswerEvaluate[0].firstArray;
                                    this.secondArray = aucAnswerEvaluate[0].secondArray;
                                    this.echartsStrValue = {
                                        xdata: [],
                                        data: []
                                    };
                                    this.isOver = true;
                                    this.$nextTick(() => {
                                        this.initEcharts()
                                    })
                                }
                                this.WxAiChatSession = dataval;
                                this.agrentData = dataval.aiApp;
                                this.agrentData.aaAppId = dataval.aaAppId
                                // conversationInputs 保持为 JSON 字符串格式
                                this.WxAiChatSession.conversationInputs = ress.data.conversationInputs || '';
                                console.log(dataval)
                                console.log(ress.data.conversationInputs);
                                if (ress.data.conversationInputs) {
                                    this.$set(this, 'inputsInfo', JSON.parse(ress.data.conversationInputs));
                                    console.log(this.inputsInfo)
                                }
                                this.diaArr = []
                                this.getAiAppInputsKey2()
                                ress.data.aiUserChatMsgList.forEach(element => {
                                    if (element.yuamrQuestion) {
                                        const query = {
                                            conter: element.yuamrQuestion,
                                            type: 2
                                        }
                                        this.diaArr.push(query)
                                        if (element.yuamrAnswer) {
                                            const query = {
                                                conter: element.yuamrAnswer,
                                                think: element.yuamrThink ? element.yuamrThink : '',
                                                fileList: element.yuamrFiles ? JSON.parse(element.yuamrFiles) : [],
                                                yuamrId: element.yuamrId ? element.yuamrId : '',
                                                messageId: element.messageId ? element.messageId : '',
                                                type: 1,
                                                IsCollapse: true,
                                                stop: true,
                                            }
                                            this.diaArr.push(query);
                                            this.isPopup = false;
                                            this.theConversationId = element.conversationId

                                        }
                                    }
                                });
                            }
                        })
                        return
                    }
                    getAiAppDetails({
                        aaId: newVal.aaId
                    }).then(res => {
                        this.agrentData = res.data;
                        this.agrentData.aaAppId = newVal.aaScene == 2 ? newVal.aaAppId : res.data.aaAppId
                        this.diaArr = []
                        this.isAfterAnswer = false
                        this.isStreamEnd = false
                        this.IsFlieShow = false
                        this.WxAiChatSession = res.data;
                        this.WxAiChatSession.conversationId = '';
                        this.WxAiChatSession.conversationInputs = '';
                        this.userInfo = localStorage.getItem('aojuAi_userName')
                        this.getAiAppInputsKey()
                    })
                }
            },
            deep: true,
            immediate: true,
        },
        query: {
            handler(newVal, oldVal) {
                if (newVal && newVal != '') {
                    if (this.isOver) {
                        return this.$message({
                            message: '本次演练已结束,请重新开始训练',
                            type: 'success'
                        });
                    }
                    const myMsg = {
                        type: 2,
                        conter: newVal
                    }
                    console.log(this.uploadFiles);

                    if (this.uploadFiles && this.uploadFiles.length > 0) {
                        myMsg.difyFiles = this.uploadFiles;
                    }
                    const load = {
                        type: 3,
                        conter: '我正在努力思考，请稍等',
                        stop: false,
                    }
                    this.diaArr.push(myMsg)
                    this.diaArr.push(load);
                    console.log(this.diaArr);
                    this.getTime();
                    this.Dify_requestTask_api(newVal)
                }
            },
            deep: true
        },
        uploadFiles: {
            handler(newVal, oldVal) {
                console.log(newVal, oldVal);
                if (newVal && newVal.length > 0) {
                    console.log(newVal);
                }
            },
            deep: true
        }


    },
    created() {

    },
    mounted() {

    },
    methods: {
        handleInputsInfoChange(newVal) {
            // 同步更新 WxAiChatSession.conversationInputs 和 inputsInfo
            this.WxAiChatSession.conversationInputs = JSON.stringify(newVal);
            this.$set(this, 'inputsInfo', newVal);
        },
        initEcharts() {
            var that = this
            var maxNum = "";
            that.isOver = true;
            that.echartsStrValue.xdata = that.secondArray
            that.firstArray.forEach(
                (items, index) => {
                    that.echartsStrValue.data.push({
                        name: items,
                        max: ""
                    });
                }
            );
            maxNum = Math.max(...that.echartsStrValue.xdata);
            that.echartsStrValue.data.forEach(item => {
                item.max = maxNum;
            });

            console.log(echarts);
            that.$nextTick(() => {
                that.echartsStr.resize()
            })
            that.echartsStr = echarts.init(that.$refs.eCharts1);
            that.echartsStr.setOption({
                darkMode: " auto",
                colorBy: "series",
                color: that.color,
                // backgroundColor: '#100C2A',


                tooltip: {
                    trigger: "item"
                }, //提示框组件 ---数据项图形触发
                legend: {
                    // orient: 'vertical', //图标列表的布局朝向
                    right: "3%",
                    top: "3%",
                    data: ["训练分析"]
                },
                radar: {
                    // shape: 'circle',
                    indicator: that.echartsStrValue.data
                },
                series: [
                    {
                        type: "radar",
                        radius: "100%",
                        data: [
                            {
                                value: that.echartsStrValue.xdata,
                                name: ""
                            }
                        ],

                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)"
                            }
                        }
                    }
                ]
            });


        },
        processAnchorLink(browserCompleteHref) {
            const myCustomPrefix = "https://dify.aojuai.com/";
            const defaultPagePrefix = window.location.origin; // 关键：可靠获取当前页面的基础前缀
            console.log('当前页面默认前缀：', defaultPagePrefix); // 输出：http://192.168.11.169:8081

            // 步骤2：剥离默认前缀，还原大模型返回的原始链接形态
            // 注意：加 ? 表示非贪婪匹配，同时兼容链接开头是否有 / 的情况
            const regRemoveDefaultPrefix = new RegExp(`^${defaultPagePrefix}\/?`, 'i');
            let originalLink = browserCompleteHref.replace(regRemoveDefaultPrefix, '');
            console.log('剥离默认前缀后（原始链接形态）：', originalLink); // 输出：file/tools/6026981a-ba64-42...

            // 步骤3：对原始链接进行精准判断（此时才是大模型返回的真实链接格式）
            const isRealCompleteLink = /^https?:\/\//i.test(originalLink); // 判断原始链接是否是真正的完整链接
            const isFileToolsRelativeLink = /^files\/tools/i.test(originalLink); // 判断原始链接是否是file/tools开头的相对链接

            if (isRealCompleteLink) {
                // 情况A：大模型返回的真正完整链接（如 https://www.baidu.com）
                return {
                    linkType: 'real-complete',
                    originalLink: originalLink,
                    targetUrl: originalLink
                };
            } else if (isFileToolsRelativeLink) {
                // 情况B：大模型返回的file/tools相对链接（被浏览器补全了前缀）
                // 拼接自定义前缀，生成目标链接
                const customUrl = myCustomPrefix + originalLink.replace(/^\//, ''); // 清理多余斜杠
                return {
                    linkType: 'file-tools-relative',
                    originalLink: originalLink, // 大模型返回的原始相对链接
                    browserCompleteHref: browserCompleteHref, // 浏览器补全后的伪完整链接
                    targetUrl: customUrl
                };
            } else {
                // 情况C：其他类型链接（按需自定义处理）
                return {
                    linkType: 'other-link',
                    originalLink: originalLink,
                    targetUrl: browserCompleteHref
                };
            }
        },

        // 监听输出div事件
        handleLlmAnchorClick(event) {
            if (event.target.tagName.toLowerCase() === 'a') {
                event.preventDefault(); // 阻止默认跳转，统一手动处理
                // 获取浏览器补全后的完整href
                const browserCompleteHref = event.target.href;
                console.log('浏览器补全后的href：', browserCompleteHref); // 输出：http://192.168.11.169:8081/files/tools/...

                // 处理链接（精准区分，无误判）
                const linkResult = this.processAnchorLink(browserCompleteHref);

                // 打印处理结果，便于调试
                console.log('最终链接处理结果：', linkResult);

                // 4. 分类型执行后续业务逻辑
                switch (linkResult.linkType) {
                    case 'real-complete':
                        // 大模型原生完整链接：直接打开
                        // alert(`即将打开大模型返回的完整链接：${linkResult.targetUrl}`);
                        window.open(linkResult.targetUrl, '_blank');
                        break;
                    case 'file-tools-relative':
                        // file/tools相对链接：使用自定义前缀链接
                        // alert(`即将打开自定义前缀链接：${linkResult.targetUrl}`);
                        // console.log('大模型返回的原始相对链接：', linkResult.originalLink);
                        window.open(linkResult.targetUrl, '_blank');
                        break;
                    default:
                        // 其他链接：按默认逻辑处理
                        // alert(`即将打开其他链接：${linkResult.targetUrl}`);
                        window.open(linkResult.targetUrl, '_blank');
                        break;
                }
            }
        },
        // 导出word
        outWord(val) {
            this.openLoading()
            exportAiUserChatMsgWord({ yuamrId: val.yuamrId }).then((res) => {
                if (res.status == 200) {
                    this.loadings.close();
                    window.location.href = res.data;
                    this.$message({
                        type: "success",
                        message: "导出成功",
                    });
                }
            });
        },
        // 问答
        queryClick(val) {
            const myMsg = {
                type: 2,
                conter: val
            }
            const load = {
                type: 3,
                conter: '我正在努力思考，请稍等',
                stop: false,
            }
            this.diaArr.push(myMsg)
            this.diaArr.push(load)
            this.getTime();
            this.AnswerIndex = 0;
            this.btnDisabled = true;
            this.Dify_requestTask_api(val)
        },
        // 点赞
        zanClick(index) {
            var that = this
            const messageId = that.diaArr[index].messageId;
            const isZanAcitve = that.diaArr[index].isZanAcitve;
            if (isZanAcitve) {
                const s = JSON.stringify({ rating: null, user: `web-${that.userInfo}`, content: '', })
                axios({
                    method: 'POST',
                    url: that.agrentData.aaAppBaseUrl + `/messages/${messageId}/feedbacks`,
                    data: s,
                    timeout: 1200000,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${that.agrentData.aaAppId}`
                    }
                }).then(function (res) {
                    if (res.data.result == 'success') {
                        that.$set(that.diaArr[index], 'isZanAcitve', false);
                    }
                }).catch(function (error) {
                    that.$message({
                        message: '该消息已过期,请重新开始对话',
                        type: 'error'
                    });
                });
            } else {
                const s = JSON.stringify({ rating: 'like', user: `web-${that.userInfo}`, content: '', });
                axios({
                    method: 'POST',
                    url: that.agrentData.aaAppBaseUrl + `/messages/${messageId}/feedbacks`,
                    data: s,
                    timeout: 1200000,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${that.agrentData.aaAppId}`
                    }
                }).then(function (res) {
                    if (res.data.result == 'success') {
                        that.$set(that.diaArr[index], 'isZanAcitve', true);
                    }
                }).catch(function (error) {
                    that.$message({
                        message: '该消息已过期,请重新开始对话',
                        type: 'error'
                    });
                });
            }

        },
        unZanClick(index) {
            var that = this
            const messageId = that.diaArr[index].messageId;
            const isUnZanAcitve = that.diaArr[index].isUnZanAcitve;
            if (isUnZanAcitve) {
                const s = JSON.stringify({ rating: null, user: `web-${that.userInfo}`, content: '', })
                axios({
                    method: 'POST',
                    url: that.agrentData.aaAppBaseUrl + `/messages/${messageId}/feedbacks`,
                    data: s,
                    timeout: 1200000,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${that.agrentData.aaAppId}`
                    }
                }).then(function (res) {
                    if (res.data.result == 'success') {
                        that.$set(that.diaArr[index], 'isUnZanAcitve', false);
                    }
                }).catch(function (error) {
                    that.$message({
                        message: '该消息已过期,请重新开始对话',
                        type: 'error'
                    });
                });
            } else {
                const s = JSON.stringify({ rating: 'dislike', user: `web-${that.userInfo}`, content: '', })
                axios({
                    method: 'POST',
                    url: that.agrentData.aaAppBaseUrl + `/messages/${messageId}/feedbacks`,
                    data: s,
                    timeout: 1200000,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${that.agrentData.aaAppId}`
                    }
                }).then(function (res) {
                    if (res.data.result == 'success') {
                        that.$set(that.diaArr[index], 'isUnZanAcitve', true);
                    }
                }).catch(function (error) {
                    console.log(error);
                    that.$message({
                        message: '该消息已过期,请重新开始对话',
                        type: 'error'
                    });
                });
            }

        },
        collectClick(index) {
            const yuamrId = this.diaArr[index].yuamrId;
            const isCollect = this.diaArr[index].isCollect;
            console.log(this.diaArr);
            if (isCollect) {
                deleteAiUserChatCollection({
                    auccId: this.diaArr[index].auccId,
                }).then(res => {
                    if (res.status == 200) {
                        this.diaArr[index].isCollect = false;
                        this.diaArr[index].auccId = null;
                    }
                })
            } else {
                addAiUserChatCollection({
                    yuamrIds: JSON.stringify([yuamrId]),
                    aucId: this.WxAiChatSession.aucId,
                }).then(res => {
                    if (res.status == 200) {
                        this.$set(this.diaArr[index], 'auccId', res.data.auccId);
                        this.$set(this.diaArr[index], 'isCollect', true);
                    }
                })
            }

        },
        // 重新问答
        restConter(index) {
            const qury = this.diaArr[index - 1].conter;
            const yuamrId = this.diaArr[index].yuamrId;
            if (yuamrId) {
                deleteAiUserChat({
                    yuamrId: yuamrId
                }).then(res => {
                    if (res.status == 200) {
                        this.diaArr.splice(index - 1, 2)
                        const myMsg = {
                            type: 2,
                            conter: qury
                        }
                        const load = {
                            type: 3,
                            conter: '我正在努力思考，请稍等',
                            stop: false,
                        }
                        this.diaArr.push(myMsg)
                        this.diaArr.push(load)
                        this.getTime();
                        this.AnswerIndex = 0;
                        this.btnDisabled = true;
                        this.Dify_requestTask_api(qury)
                    }
                })
            } else {
                this.diaArr.splice(index - 1, 2)
                const myMsg = {
                    type: 2,
                    conter: qury
                }
                const load = {
                    type: 3,
                    conter: '我正在努力思考，请稍等',
                    stop: false,
                }
                this.diaArr.push(myMsg)
                this.diaArr.push(load)
                this.getTime();
                this.AnswerIndex = 0;
                this.btnDisabled = true;
                this.Dify_requestTask_api(qury)
            }
        },
        // 开场白的例子
        gotoEg(e) {
            const text = e
            const myMsg = {
                type: 2,
                conter: text
            }
            const load = {
                type: 3,
                conter: '我正在努力思考，请稍等',
                stop: false,
            }
            this.diaArr.push(myMsg)
            this.diaArr.push(load);
            this.getTime();
            this.AnswerIndex = 0;
            this.btnDisabled = true;

            this.Dify_requestTask_api(text)
            this.autoScroll()
        },
        // 优化后的Vue2 Web端Dify_requestTask_api方法（完整可运行）
        Dify_requestTask_api(val) {
            const vm = this;
            // ========== 1. 初始化响应式状态（新增message_end相关兜底标记） ==========
            vm.DmxInit();
            vm.isMerge = false;
            vm.mergeArr = [];
            vm.uncompletedLine = '';
            vm.loadingText = '.';
            vm.loadingNums = 0;
            vm.totalAnswerText = ''; // 完整文本池
            vm.displayAnswerText = ''; // 展示文本
            vm.isTyping = false; // 打字状态
            vm.isStreamEnd = false; // 流结束标记
            vm.forceStreamEnd = false; // 新增：强制流结束标记（最高优先级）
            vm.theItem = null;
            vm.theConversationId = '';
            vm.messageEndFragments = []; // 新增：缓存message_end相关片段
            vm.hasDetectedMessageEnd = false; // 新增：是否检测到message_end

            // 清除残留定时器（Vue2内存泄漏防护）
            if (vm.typingTimer) {
                clearInterval(vm.typingTimer);
                vm.typingTimer = null;
            }
            if (vm.timeID) {
                clearInterval(vm.timeID);
                vm.timeID = null;
            }

            // ========== 2. 封装：打字机核心逻辑（新增forceStreamEnd检测） ==========
            const startTyping = () => {
                if (vm.isTyping) return;
                // 无文本但流结束/强制结束，直接执行收尾
                if (vm.totalAnswerText.length === 0) {
                    if (vm.isStreamEnd || vm.forceStreamEnd) {
                        vm.finishStreamProcessing();
                    }
                    return;
                }

                vm.isTyping = true;
                let currentIndex = vm.displayAnswerText.length;
                // Vue2定时器挂载到实例，方便销毁
                vm.typingTimer = setInterval(() => {
                    if (currentIndex < vm.totalAnswerText.length) {
                        // 逐字渲染逻辑
                        const newDisplayText = vm.totalAnswerText.substring(0, currentIndex + 1);
                        currentIndex++;
                        const html = md.render(newDisplayText);
                        vm.$set(vm.diaArr[vm.diaArr.length - 1], 'conter', html);
                        vm.displayAnswerText = newDisplayText;
                        vm.autoScroll();
                    } else {
                        // 渲染完成，检测收尾标记
                        clearInterval(vm.typingTimer);
                        vm.typingTimer = null;
                        vm.isTyping = false;
                        if (vm.isStreamEnd || vm.forceStreamEnd) {
                            vm.finishStreamProcessing();
                        }
                    }
                }, vm.typingSpeed || 30);
            };

            // ========== 3. 封装：追加文本到字符池（无修改，保留原始逻辑） ==========
            const appendAnswerText = (newText) => {
                if (!newText) return;
                vm.totalAnswerText = vm.totalAnswerText + newText;
                startTyping();
            };

            // ========== 4. 新增核心：拼接message_end片段并二次解析 ==========
            const tryParseMessageEndFromFragments = () => {
                if (!vm.messageEndFragments || vm.messageEndFragments.length === 0) return null;

                // 拼接所有message_end片段
                let fullMsgEndStr = '';
                vm.messageEndFragments.forEach(frag => {
                    if (!frag || !frag.content) return;
                    let rawStr = frag.content;
                    // 去除data: 前缀
                    if (typeof rawStr === 'string' && rawStr.startsWith('data: ')) {
                        rawStr = rawStr.substring(6).trim();
                    }
                    // 过滤空字符串
                    if (rawStr) {
                        fullMsgEndStr += typeof rawStr === 'string' ? rawStr : JSON.stringify(rawStr);
                    }
                });

                if (!fullMsgEndStr) return null;
                // 修复JSON格式错误，提高解析成功率
                fullMsgEndStr = fullMsgEndStr
                    .replace(/\s+/g, ' ')
                    .replace(/,}/g, '}')
                    .replace(/,]/g, ']')
                    .trim();

                // 尝试解析message_end对象
                try {
                    const msgEndObj = JSON.parse(fullMsgEndStr);
                    if (msgEndObj && msgEndObj.event === 'message_end') {
                        vm.forceStreamEnd = true; // 标记强制结束
                        return msgEndObj;
                    }
                } catch (e) {
                    return null;
                }
                return null;
            };

            // ========== 5. 封装：解析单行流式数据（新增message_end片段捕获） ==========
            const processSingleLine = (line) => {
                let jsonObj = null;
                if (!line || !line.startsWith('data: ')) return jsonObj;

                try {
                    const jsonString = line.substring(6).trim();
                    if (jsonString === '[DONE]' || jsonString === '') return null;

                    // 捕获包含message_end的片段
                    if (jsonString.includes('message_end')) {
                        vm.messageEndFragments.push({
                            type: '单行解析前',
                            content: jsonString,
                            timestamp: new Date().getTime()
                        });
                        vm.hasDetectedMessageEnd = true;
                    }

                    jsonObj = JSON.parse(jsonString);
                    // 捕获解析成功的message_end对象
                    if (jsonObj && jsonObj.event === 'message_end') {
                        vm.messageEndFragments.push({
                            type: '解析成功',
                            content: jsonObj,
                            timestamp: new Date().getTime()
                        });
                        vm.hasDetectedMessageEnd = true;
                    }
                } catch (e) {
                    // 捕获解析失败的message_end片段
                    if (line.includes('message_end')) {
                        vm.messageEndFragments.push({
                            type: '解析失败',
                            content: line,
                            error: e.message,
                            timestamp: new Date().getTime()
                        });
                        vm.hasDetectedMessageEnd = true;
                    }
                    vm.uncompletedLine = line;
                }
                return jsonObj;
            };

            // ========== 6. 封装：解析流式数据分片（新增二次解析逻辑） ==========
            const parseStreamData = (rawStr) => {
                const jsonObjects = [];
                const uncompletedLine = vm.uncompletedLine;
                const fullStr = uncompletedLine + rawStr;
                const lines = fullStr.split('\n');
                const lastLine = lines.pop() || '';

                // 捕获完整字符串中的message_end
                if (fullStr.includes('message_end')) {
                    vm.messageEndFragments.push({
                        type: '完整字符串',
                        content: fullStr,
                        timestamp: new Date().getTime()
                    });
                    vm.hasDetectedMessageEnd = true;
                }

                // 逐行解析
                lines.forEach(line => {
                    if (line.includes('message_end')) {
                        vm.messageEndFragments.push({
                            type: '单行待解析',
                            content: line,
                            timestamp: new Date().getTime()
                        });
                        vm.hasDetectedMessageEnd = true;
                    }
                    const jsonObj = processSingleLine(line);
                    if (jsonObj) jsonObjects.push(jsonObj);
                });

                // 处理最后一行
                if (lastLine) {
                    if (lastLine.includes('message_end')) {
                        vm.messageEndFragments.push({
                            type: '最后一行未解析',
                            content: lastLine,
                            timestamp: new Date().getTime()
                        });
                        vm.hasDetectedMessageEnd = true;
                    }
                    const tempObj = processSingleLine(lastLine);
                    if (tempObj) {
                        jsonObjects.push(tempObj);
                        vm.uncompletedLine = '';
                    } else {
                        vm.uncompletedLine = lastLine;
                    }
                } else {
                    vm.uncompletedLine = '';
                }

                // 二次解析message_end片段（核心修复）
                if (vm.hasDetectedMessageEnd) {
                    const fullMsgEndObj = tryParseMessageEndFromFragments();
                    if (fullMsgEndObj) {
                        handleMessageItem(fullMsgEndObj);
                        vm.messageEndFragments = []; // 清空片段，避免重复解析
                        vm.hasDetectedMessageEnd = false;
                        startTyping(); // 强制触发打字机
                    }
                }

                return jsonObjects;
            };

            // ========== 7. 封装：处理消息项（新增forceStreamEnd标记） ==========
            const handleMessageItem = (item) => {
                if (!item) return;

                if (item.conversation_id) {
                    vm.theConversationId = item.conversation_id;
                    vm.theTaskId = item.task_id;
                }

                // 处理普通消息
                if (item.event === 'message' && item.event !== 'message_end') {
                    if (vm.DmxIndex === 1) {
                        vm.diaArr.splice(vm.diaArr.length - 1, 1);
                        const AiMsg = {
                            type: 1,
                            conter: '',
                            FollowUpQuery: [],
                            think: '',
                            stop: false,
                            IsCollapse: true,
                        };
                        vm.diaArr.push(AiMsg);
                        if (vm.timeID) clearInterval(vm.timeID);
                        vm.isOpen = true;
                        vm.loadingText = '.';
                        vm.loadingNums = 0;
                    }
                    vm.$set(vm.diaArr[vm.diaArr.length - 1], 'messageId', item.message_id || '');
                    const newAnswerChars = item.answer || '';
                    if (newAnswerChars) {
                        appendAnswerText(newAnswerChars);
                    }

                    vm.AnswerIndex = vm.AnswerIndex + 1;
                    vm.DmxIndex = vm.DmxIndex + 1;
                }

                // 处理流结束
                if (item.event === 'message_end') {

                    if (item.metadata && item.metadata.retriever_resources.length > 0) {
                        vm.$set(vm.diaArr[vm.diaArr.length - 1], 'fileList', item.metadata.retriever_resources);
                    }
                    vm.theItem = item;
                    vm.isStreamEnd = true;
                    vm.forceStreamEnd = true; // 强制标记结束
                    if (!vm.isTyping) {
                        startTyping();
                    }
                }
            };

            // ========== 8. 封装：流结束收尾（保留原始逻辑，优化状态重置） ==========
            vm.finishStreamProcessing = function () {
                // 清除所有定时器
                if (vm.timeID) clearInterval(vm.timeID);
                if (vm.typingTimer) clearInterval(vm.typingTimer);
                vm.typingTimer = null;
                vm.isTyping = false;

                // 更新结束状态
                vm.$set(vm.diaArr[vm.diaArr.length - 1], 'stop', true);
                vm.isOpen = false;
                vm.btnDisabled = false;
                vm.isStreamEnd = false;
                vm.forceStreamEnd = false; // 重置强制结束标记
                vm.messageEndFragments = []; // 清空片段缓存
                vm.hasDetectedMessageEnd = false;

                // 提示用户
                vm.$message({
                    message: '回答已完成',
                    type: 'info',
                    duration: 1500
                });

                // 保存会话记录
                const conversationId = vm.WxAiChatSession.conversationId || vm.theConversationId;
                if (conversationId) {
                    if (vm.WxAiChatSession.conversationId === '') {
                        vm.addChatMsgOne_Dify(conversationId, vm.theTaskId);
                    } else {
                        addAiUserChatMsg({
                            conversationId,
                            aucId: vm.WxAiChatSession.aucId,
                            messageId: vm.diaArr[vm.diaArr.length - 1]?.messageId || '',
                            yuamrQuestion: vm.diaArr[vm.diaArr.length - 2]?.conter || '',
                            difyFiles: vm.diaArr[vm.diaArr.length - 2].difyFiles ? JSON.stringify(vm.diaArr[vm.diaArr.length - 2].difyFiles) : '',
                            yuamrAnswer: vm.diaArr[vm.diaArr.length - 1]?.conter || '',
                            yuamrThink: vm.diaArr[vm.diaArr.length - 1]?.think || '',
                            // yuamrFiles: vm.diaArr[vm.diaArr.length - 1].fileList ? JSON.stringify(vm.diaArr[vm.diaArr.length - 1].fileList) : '',
                        }).then(res => {
                            vm.$set(vm.diaArr[vm.diaArr.length - 1], 'yuamrId', res.data?.yuamrId || '');
                            vm.$emit('getChatMsg', '');
                            if (res.data.aucStatus == 2) {
                                var aucAnswerEvaluate = JSON.parse(res.data.aucAnswerEvaluate)
                                if (aucAnswerEvaluate[0].firstArray && aucAnswerEvaluate[0].firstArray.length > 0) {
                                    vm.firstArray = aucAnswerEvaluate[0].firstArray;
                                    vm.secondArray = aucAnswerEvaluate[0].secondArray;
                                    c.echartsStrValue = {
                                        xdata: [],
                                        data: []
                                    };
                                    vm.isOver = true;
                                    vm.$nextTick(() => {
                                        that.initEcharts()
                                    })
                                }
                            }
                        }).catch(err => {
                            console.error('保存会话记录失败:', err);
                        });
                    }
                }
            };

            // ========== 9. 发起流式请求（新增finally兜底，强制解析message_end） ==========
            const abortController = new AbortController();
            vm.abortController = abortController;

            // Vue2 fetch流式请求（核心：finally兜底解析）
            fetch(`${vm.agrentData.aaAppBaseUrl}/chat-messages`, {
                method: 'POST',
                signal: abortController.signal,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${vm.WxAiChatSession.aaAppId}`
                },
                body: JSON.stringify({
                    conversation_id: vm.WxAiChatSession.conversationId || null,
                    response_mode: "streaming",
                    query: val,
                    inputs: vm.WxAiChatSession.conversationInputs || {},
                    user: `web-${vm.userInfo || '用户'}`,
                    name: 'zhangs',
                    files: vm.diaArr[vm.diaArr.length - 2].difyFiles ? vm.diaArr[vm.diaArr.length - 2].difyFiles : [],
                })
            }).then(async (response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const reader = response.body.getReader();
                const decoder = new TextDecoder('utf-8');

                while (true) {
                    // 检测手动停止
                    if (vm.isStop) {
                        abortController.abort();
                        reader.cancel();
                        if (vm.typingTimer) {
                            clearInterval(vm.typingTimer);
                            vm.typingTimer = null;
                            vm.isTyping = false;
                        }
                        return;
                    }

                    const { done, value } = await reader.read();
                    if (done) break;

                    // 解码分片数据
                    const decodeStr = decoder.decode(value, { stream: true });
                    if (!decodeStr) continue;

                    let fullDecodeStr = decodeStr;
                    if (vm.isMerge && vm.mergeArr.length > 0) {
                        fullDecodeStr = vm.mergeArr.join('') + decodeStr;
                        vm.mergeArr = [];
                    }

                    // 解析数据
                    const jsonObjects = parseStreamData(fullDecodeStr);
                    if (jsonObjects.length > 0) {
                        jsonObjects.forEach(item => handleMessageItem(item));
                        if (vm.uncompletedLine) {
                            vm.isMerge = true;
                        }
                    } else {
                        vm.mergeArr.push(fullDecodeStr);
                        vm.isMerge = true;
                        vm.loadingText = '';
                        vm.loadingNums = 0;
                    }
                }
            }).catch((err) => {
                console.error('请求失败:', err);
                // 错误处理：清除定时器，重置状态
                if (vm.timeID) clearInterval(vm.timeID);
                if (vm.typingTimer) clearInterval(vm.typingTimer);
                vm.typingTimer = null;
                vm.isTyping = false;
                vm.isStreamEnd = false;
                vm.forceStreamEnd = false;

                vm.$message.error(`请求出错: ${err.message || err}`);

                // 追加错误消息
                const errorMsg = {
                    type: 1,
                    conter: '请询问的再详细些'
                };
                vm.diaArr.push(errorMsg);

                // 重置状态
                vm.AnswerIndex = 0;
                vm.displayAnswerText = '';
                vm.totalAnswerText = '';
                vm.btnDisabled = false;
                vm.form.question = '';
                vm.loadingNums = 0;
                vm.loadingText = '.';
                vm.uncompletedLine = '';
                vm.mergeArr = [];
                vm.messageEndFragments = [];
                vm.hasDetectedMessageEnd = false;
            }).finally(() => {
                // ========== 核心修复：请求结束（无论成功/失败）必执行最后一次解析 ==========
                if (vm.hasDetectedMessageEnd || vm.messageEndFragments.length > 0) {
                    const fullMsgEndObj = tryParseMessageEndFromFragments();
                    if (fullMsgEndObj) {
                        handleMessageItem(fullMsgEndObj);
                    } else {
                        vm.forceStreamEnd = true; // 解析失败则强制标记结束
                    }
                    startTyping(); // 强制触发打字机，执行收尾
                }
            });
        },

        // ========== 辅助方法：自动滚动（Vue2版） ==========
        autoScroll() {
            // 假设滚动容器的ref为chatScrollView
            const scrollEl = this.$refs.chatScrollView;
            if (scrollEl) {
                scrollEl.scrollTop = scrollEl.scrollHeight;
            }
        },

        // ========== 辅助方法：取消请求（Vue2版） ==========
        abortRequest() {
            if (this.abortController) {
                this.abortController.abort();
            }
        },
        // 如果没有对话id,创建第一次对话
        addChatMsgOne_Dify(val, taskId) {
            addAiUserChatOneDify({
                aaId: this.WxAiChatSession.aaId,
                aaTaskId: taskId,
                aaAppId: this.agrentData.aaAppId,
                conversationId: val,
                conversationInputs: this.WxAiChatSession.conversationInputs ? JSON.stringify(this.WxAiChatSession.conversationInputs) : ''
            }).then(res => {
                this.WxAiChatSession.conversationId = val;
                this.WxAiChatSession.aucId = res.data.aucId;
                addAiUserChatMsg({
                    conversationId: this.WxAiChatSession.conversationId,
                    aucId: this.WxAiChatSession.aucId,
                    yuamrQuestion: this.diaArr[this.diaArr.length - 2].conter,
                    difyFiles: this.diaArr[this.diaArr.length - 2].difyFiles ? JSON.stringify(this.diaArr[this.diaArr.length - 2].difyFiles) : '',
                    yuamrAnswer: this.diaArr[this.diaArr.length - 1].conter,
                    messageId: this.diaArr[this.diaArr.length - 1].messageId,
                    yuamrThink: this.diaArr[this.diaArr.length - 1].think ? this.diaArr[this.diaArr.length - 1].think : '',
                    // yuamrFiles: this.diaArr[this.diaArr.length - 1].fileList ? JSON.stringify(this.diaArr[this.diaArr.length - 1].fileList) : '',
                }).then(res => {
                    this.diaArr[this.diaArr.length - 1].yuamrId = res.data.yuamrId ? res.data.yuamrId : '';
                    if (res.data.aucStatus == 2) {
                        var aucAnswerEvaluate = JSON.parse(res.data.aucAnswerEvaluate)
                        if (aucAnswerEvaluate[0].firstArray && aucAnswerEvaluate[0].firstArray.length > 0) {
                            that.firstArray = aucAnswerEvaluate[0].firstArray;
                            that.secondArray = aucAnswerEvaluate[0].secondArray;
                            that.echartsStrValue = {
                                xdata: [],
                                data: []
                            };
                            that.isOver = true;
                            that.$nextTick(() => {
                                that.initEcharts()
                            })
                        }
                    }
                    this.$emit('getChatMsg', '');
                })
            })
        },
        openDrawer() {
            this.isDrawer = true;
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        DownFile(item) {
            this.openLoading()
            getAiKnowledgeFileUser({
                akwName: item.dataset_name,
                akfName: item.document_name
            }).then(res => {
                const suffix = item.document_name;
                FileSaver.saveAs(res.data.akfPath, suffix)
                this.loadings.close()
                // 下载成功
                this.$message({
                    showClose: true,
                    message: '下载成功',
                    type: 'success'
                });
            })

        },
        // 复制文本
        conterCopy(index) {
            const textToCopy = this.diaArr[index].conter; // 获取要复制的文本
            const plainText = this.convertHtmlToText(textToCopy); // 转换为纯文本
            if (navigator.clipboard) {
                this.copyTextToClipboardUsingClipboardAPI(plainText);
            } else {
                this.copyTextToClipboardLegacy(plainText); // 使用旧的execCommand方法（不推荐）
            }
        },
        copyTextToClipboardUsingClipboardAPI(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$message({
                    showClose: true,
                    message: '复制成功',
                    type: 'success'
                });
            }).catch(err => {
                console.error('复制失败:', err);
            });
        },
        copyTextToClipboardLegacy(text) {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed'; // 防止滚动到顶部
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                this.$message({
                    showClose: true,
                    message: '复制成功',
                    type: 'success'
                });
            } catch (err) {
                console.error('复制失败:', err);
            } finally {
                document.body.removeChild(textArea);
            }
        },
        // 大模型初始化
        DmxInit(val) {
            this.ThinkIndex = 0;
            this.DmxIndex = 0;
            this.AnswerMsg = '';
            this.ThinkMsg = '';
            this.AnswerIndex = 0;

        },
        // 中断请求
        abortStream() {
            if (this.controller) {
                this.controller.abort();
                this.isOpen = false;
                this.btnDisabled = false;

                // this.isStop = false;
                this.controller = null
            }
        },
        // 将html转纯文本
        convertHtmlToText(inputText) {
            var returnText = "" + inputText;
            returnText = returnText.replace(/<\/div>/ig, '\r\n');
            returnText = returnText.replace(/<\/li>/ig, '\r\n');
            returnText = returnText.replace(/<li>/ig, ' * ');
            returnText = returnText.replace(/<\/ul>/ig, '\r\n');
            //-- remove BR tags and replace them with line break
            returnText = returnText.replace(/<br\s*[\/]?>/gi, "\r\n");

            //-- remove P and A tags but preserve what's inside of them
            returnText = returnText.replace(/<p.*?>/gi, "\r\n");
            returnText = returnText.replace(/<a.*href="(.*?)".*>(.*?)<\/a>/gi, " $2 ($1)");

            //-- remove all inside SCRIPT and STYLE tags
            returnText = returnText.replace(/<script.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/script>/gi, "");
            returnText = returnText.replace(/<style.*>[\w\W]{1,}(.*?)[\w\W]{1,}<\/style>/gi, "");
            //-- remove all else
            returnText = returnText.replace(/<(?:.|\s)*?>/g, "");

            //-- get rid of more than 2 multiple line breaks:
            returnText = returnText.replace(/(?:(?:\r\n|\r|\n)\s*){2,}/gim, "\r\n\r\n");

            //-- get rid of more than 2 spaces:
            returnText = returnText.replace(/ +(?= )/g, '');

            //-- get rid of html-encoded characters:
            returnText = returnText.replace(/&nbsp;/gi, " ");
            returnText = returnText.replace(/&amp;/gi, "&");
            returnText = returnText.replace(/&quot;/gi, '"');
            returnText = returnText.replace(/&lt;/gi, '<');
            returnText = returnText.replace(/&gt;/gi, '>');

            return returnText;
        },
        // 收起or展开 思考
        collapseTap(index) {
            this.diaArr[index].IsCollapse = !this.diaArr[index].IsCollapse
            this.$set(this.diaArr, index, this.diaArr[index])
        },
        // 收起or展开 参考资料
        collapseFileTap(index) {
            this.diaArr[index].IsFlieShow = !this.diaArr[index].IsFlieShow
            this.$set(this.diaArr, index, this.diaArr[index])
        },
        // 
        getTime() {
            var that = this
            that.timeID = setInterval(() => {
                if (that.loadingNums >= 4) {
                    that.loadingNums = 0;
                    that.loadingText = '.'
                }
                that.loadingNums = that.loadingNums + 1,
                    that.loadingText = that.loadingText + '.'

            }, 400) //每隔1s调用一次timer函数
        },
        //获取dify智能体变量

        getAiAppInputsKey() {
            var that = this;
            console.log(that.agrentData);

            axios({
                method: 'get',
                url: that.agrentData.aaAppBaseUrl + '/parameters',
                data: '',
                timeout: 1200000,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${that.agrentData.aaAppId}`
                }
            }).then(function (res) {
                console.log(res)
                that.agentVarObj = [];
                that.agentVar = [];
                if (res.data.opening_statement) {
                    that.prologue = {
                        textValue: res.data.opening_statement,
                        type: 4,
                        stop: false,
                        eg: res.data.suggested_questions ? res.data.suggested_questions : [],
                    }

                }
                if (res.data.user_input_form && res.data.user_input_form.length > 0) {
                    console.log('11');
                    res.data.user_input_form.forEach((item, index) => {
                        if (item.select) {
                            that.$set(that.inputsInfo, item.select.variable, item.select.default)
                            that.$set(that.agentVarObj, item.select.variable, {
                                options: [],
                                rule: '',
                                required: false
                            })
                            that.agentVarObj[item.select.variable].options = item.select.options.map(items => {
                                return {
                                    text: items,
                                    value: items
                                }
                            })
                            that.agentVarObj[item.select.variable].rule = '请选择' + item.select.label
                            that.agentVarObj[item.select.variable].required = item.select.required
                        }
                        if (item.paragraph) {
                            that.$set(that.inputsInfo, item.paragraph.variable, item.paragraph.default)
                            that.agentVarObj[item.paragraph.variable] = {
                                rule: '',
                                required: false
                            }
                            that.agentVarObj[item.paragraph.variable].rule = '请选择' + item.paragraph.label
                            that.agentVarObj[item.paragraph.variable].required = item.paragraph.required
                        }
                        if (item['text-input']) {
                            // that.inputsInfo[item['text-input'].variable] = item['text-input'].default;
                            that.$set(that.inputsInfo, item['text-input'].variable, item['text-input'].default)
                            that.agentVarObj[item['text-input'].variable] = {
                                rule: '',
                                required: false
                            }
                            that.agentVarObj[item['text-input'].variable].rule = '请选择' + item['text-input'].label
                            that.agentVarObj[item['text-input'].variable].required = item['text-input'].required
                        }
                        if (item.number) {
                            that.$set(that.inputsInfo, item.number.variable, item.number.default)
                            that.agentVarObj[item.number.variable] = {
                                rule: '',
                                required: false
                            }
                            that.agentVarObj[item.number.variable].rule = '请选择' + item.number.label
                            that.agentVarObj[item.number.variable].required = item.number.required
                        }
                        // this.triggerEvent('agentVarChange', {
                        //     value: this.data.agentVar,
                        // });
                    })
                    that.$set(that, 'inputsInfo', that.inputsInfo)
                    that.$set(that, 'agentVarObj', that.agentVarObj)
                    console.log(that.agentVarObj, that.inputsInfo);
                    that.agentVar = res.data.user_input_form
                }
                if (res.data.suggested_questions_after_answer.enabled) {
                    that.isAfterAnswer = true
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        getAiAppInputsKey2() {
            var that = this;
            axios({
                method: 'get',
                url: that.agrentData.aaAppBaseUrl + '/parameters',
                data: '',
                timeout: 1200000,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${that.agrentData.aaAppId}`
                }
            }).then(function (res) {
                console.log(res)
                // 保留现有的 inputsInfo 值，只更新不存在的字段
                const existingInputsInfo = {...that.inputsInfo};
                that.agentVarObj = [];
                that.agentVar = [];
                if (res.data.user_input_form && res.data.user_input_form.length > 0) {
                    console.log('11');
                    res.data.user_input_form.forEach((item, index) => {
                        if (item.select) {
                            // 优先使用已有值，没有才使用 default
                            const currentValue = existingInputsInfo[item.select.variable];
                            that.$set(that.inputsInfo, item.select.variable, currentValue !== undefined ? currentValue : item.select.default)
                            that.$set(that.agentVarObj, item.select.variable, {
                                options: [],
                                rule: '',
                                required: false
                            })
                            that.agentVarObj[item.select.variable].options = item.select.options.map(items => {
                                return {
                                    text: items,
                                    value: items
                                }
                            })
                            that.agentVarObj[item.select.variable].rule = '请选择' + item.select.label
                            that.agentVarObj[item.select.variable].required = item.select.required
                        }
                        if (item.paragraph) {
                            // 优先使用已有值，没有才使用 default
                            const currentValue = existingInputsInfo[item.paragraph.variable];
                            that.inputsInfo[item.paragraph.variable] = currentValue !== undefined ? currentValue : item.paragraph.default;
                            that.$set(that.inputsInfo, item.paragraph.variable, currentValue !== undefined ? currentValue : item.paragraph.default)
                            that.agentVarObj[item.paragraph.variable] = {
                                rule: '',
                                required: false
                            }
                            that.agentVarObj[item.paragraph.variable].rule = '请选择' + item.paragraph.label
                            that.agentVarObj[item.paragraph.variable].required = item.paragraph.required
                        }
                        if (item['text-input']) {
                            // 优先使用已有值，没有才使用 default
                            const currentValue = existingInputsInfo[item['text-input'].variable];
                            // that.inputsInfo[item['text-input'].variable] = item['text-input'].default;
                            // that.$set(that.inputsInfo, item['text-input'].variable, currentValue !== undefined ? currentValue : item['text-input'].default)
                            that.agentVarObj[item['text-input'].variable] = {
                                rule: '',
                                required: false
                            }
                            that.agentVarObj[item['text-input'].variable].rule = '请选择' + item['text-input'].label
                            that.agentVarObj[item['text-input'].variable].required = item['text-input'].required
                        }
                        if (item.number) {
                            // 优先使用已有值，没有才使用 default
                            const currentValue = existingInputsInfo[item.number.variable];
                            that.inputsInfo[item.number.variable] = currentValue !== undefined ? currentValue : item.number.default;
                            that.$set(that.inputsInfo, item.number.variable, currentValue !== undefined ? currentValue : item.number.default)
                            that.agentVarObj[item.number.variable] = {
                                rule: '',
                                required: false
                            }
                            that.agentVarObj[item.number.variable].rule = '请选择' + item.number.label
                            that.agentVarObj[item.number.variable].required = item.number.required
                        }

                        // this.triggerEvent('agentVarChange', {
                        //     value: this.data.agentVar,
                        // });
                    })
                    that.$set(that, 'agentVarObj', that.agentVarObj)
                    that.$set(that, 'inputsInfo', that.inputsInfo)
                    that.agentVar = res.data.user_input_form;
                    console.log(that.agentVarObj, that.inputsInfo);

                }
                if (res.data.suggested_questions_after_answer.enabled) {
                    that.isAfterAnswer = true
                }
                if (res.data.opening_statement) {
                    that.prologue = {
                        textValue: res.data.opening_statement,
                        type: 4,
                        stop: false,
                        eg: res.data.suggested_questions ? res.data.suggested_questions : [],
                    }

                }
            }).catch(function (error) {
                console.log(error);
            });
        },

    }
};
</script>
<style scoped>
.file-list {
    margin-top: 10px;
}

/* 右上角删除按钮（核心样式） */
.file-delete-btn {
    position: absolute;
    top: 3px;
    right: 0px;
}

.file-delete-btn .el-button {
    color: black;
    padding: 0;
    width: 16px;
    height: 16px;
    display: flex;
    font-size: 12px;
    align-items: center;
    justify-content: center;
}

.file-delete-btn .el-button:hover {
    background-color: #fee;
    border-radius: 50%;
}

.file-item {
    display: flex;
    align-items: center;
    padding: 8px 18px;
    background: #f8f9fa;
    border-radius: 4px;
    position: relative;
    margin: 10px;
    /* 关键：给删除按钮定位 */
}

.file-icon {
    font-size: 24px;
    color: #409eff;
    margin-right: 12px;
}

.file-info {
    flex: 1;
}

.file-name {
    font-size: 14px;
    color: #333;
}

.file-meta {
    font-size: 12px;
    color: #999;
    margin-top: 2px;
}

.textWrapClass {
    white-space: pre-wrap;
    word-break: break-all;
    word-wrap: break-word;

}

.egclass {
    position: relative;
    max-width: 98%;
    margin: 10px 10px 10px;
    padding: 15px 10px 10px;
    /* background-image: url('https://txcloud.aojuai.com/icon/aojv/aiwx_icon/dhk.png'); */
    /* background-repeat: no-repeat; */
    background-color: #f7f8f9;
    /* background-size: cover; */
    font-size: 16px;
    border-radius: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    word-wrap: break-word;
    /* 强制换行 */
    word-break: break-all;
    /* 英文/数字强制换行 */
}

.message {
    position: relative;
    max-width: 98%;
    margin: 10px;
    padding: 10px;
    background-color: white;
    /* background: linear-gradient(to bottom, #accdf1, white); */
    font-size: 22rpx;
    border-radius: 15px;
    /* display: flex; */
    /* z-index: 10; */
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    word-wrap: break-word;
    /* 强制换行 */
    word-break: break-all;
    /* 英文/数字强制换行 */
}

.login-container {
    max-width: 400px;
    margin: 50px auto;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    font-family: 'Arial', sans-serif;

}

h2 {
    text-align: center;
    color: #333333;
    font-size: 24px;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
    color: #555555;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    border: 1px solid #cccccc;
    border-radius: 5px;
    font-size: 16px;
    transition: border-color 0.3s, box-shadow 0.3s;
}

input:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25);
}

button {
    width: 100%;
    padding: 12px;
    background-color: #42b983;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
}

button:hover {
    background-color: #36956f;
}

.egTitleclass {
    font-size: 21px;
    font-weight: bold;
    position: absolute;
    top: 0px;
    left: 10px;
}

.inputDiv {
    width: calc(100% - 300px - 35%);
    min-height: 130px;
    position: fixed;
    bottom: 20px;
    left: calc(300px + 17%);
    border-radius: 15px;
    border: 1px solid #DCDFE6;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.inputDiv div /deep/ .el-textarea__inner {
    border: none !important;
    resize: none !important;
}

.iconStyle {
    width: 40px;
    height: 40px;
    margin: 10px;
    font-size: 22px;
}

.iconStyle_icon {
    width: 20px;
    height: 20px;
}

.flex-right {
    flex-direction: row-reverse;
}

.flex-right>.message::after {
    left: unset;
    right: -5px;
}

.message2 {
    position: relative;
    max-width: 98%;
    margin: 10px;
    padding: 10px;
    background: white;
    border-radius: 10px 10px 0 10px;
    font-size: 16px;
    color: black;
    /* display: flex; */
    /* z-index: 10; */
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    word-wrap: break-word;
    /* 强制换行 */
    word-break: break-all;
    /* 英文/数字强制换行 */
}

.aoju_title {
    width: calc(100% - 15%);
    font-size: 26px;
    font-weight: 600;
}

@media (max-width: 600px) {
    .aoju_title {
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

    }

    .inputDiv {
        width: 95%;
        min-height: 80px;
        position: fixed;
        bottom: 10px;
        left: 2.5%;
        border-radius: 15px;
        border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }

    .egTitleclass {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        top: 0px;
        left: 10px;
    }

    .mainDiv {
        width: 100% !important;
        height: calc(100% - 100px) !important;

    }

    .login-container {
        padding: 30px;
    }

    h2 {
        font-size: 20px;
    }

    input,
    button {
        font-size: 14px;
        padding: 10px;
    }

    .egclass {
        position: relative;
        max-width: 98% !important;
        margin: 20px 0px 0px;
        padding: 20px 10px 10px;
        /* background-image: url('https://txcloud.aojuai.com/icon/aojv/aiwx_icon/dhk.png'); */
        /* background-repeat: no-repeat; */
        background-color: white;
        /* background-size: cover; */
        font-size: 12px;
        border-radius: 30px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        word-wrap: break-word;
        /* 强制换行 */
        word-break: break-all;
        /* 英文/数字强制换行 */
    }

    .message2 {
        position: relative;
        max-width: 98%;
        margin: 10px;
        padding: 10px;
        background: white;
        border-radius: 5px 5px 0 5px;
        font-size: 10px !important;
        color: black;
        /* display: flex; */
        /* z-index: 10; */
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        word-wrap: break-word;
        /* 强制换行 */
        word-break: break-all;
        /* 英文/数字强制换行 */
    }

    /* 确保没有不必要的外部边距或填充 */
    ol,
    ul,
    dl {
        padding-left: 20px !important;
        /* 移除默认的左填充 */
        margin: 0;
        /* 移除默认的外边距 */
    }

    .message {
        position: relative;
        max-width: 98%;
        margin: 10px;
        padding: 10px;
        /* padding-left: 15px !important; */
        background-color: white;
        /* background: linear-gradient(to bottom, #accdf1, white); */
        border-radius: 15px;
        font-size: 10px !important;
        /* display: flex; */
        /* z-index: 10; */
        overflow: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        word-wrap: break-word;
        /* 强制换行 */
        word-break: break-all;
        /* 英文/数字强制换行 */
    }

}
</style>